export class DSLLoader {
    constructor() {
        // Content JSON is locale-independent (copy is resolved separately via
        // "i18n:..." references), so a page fetched once can be reused across
        // repeat navigations and language switches without a redundant round trip.
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
    }
    async load(pageId) {
        const cached = this.cache.get(pageId);
        if (cached)
            return cached;
        const response = await fetch(`/content/${pageId}.json`);
        if (!response.ok) {
            throw new Error(`Failed to load page DSL for "${pageId}": ${response.status}`);
        }
        const page = (await response.json());
        this.cache.set(pageId, page);
        return page;
    }
}
